export default __webpack_public_path__ + "static/media/DerpyDetails.19ba70d5.gif";